import React, { useCallback } from "react";
import { db } from "@/db";
import { IndexableType } from "dexie";
import axios from "axios";
import Resizer from "react-image-file-resizer";

type OfflineImageContent = {
  loadOfflineImage: (url: string) => Promise<string | undefined>;
  saveImage: (url: string, postId: number) => Promise<IndexableType | undefined>;
};

export const useOfflineImageContent = (): OfflineImageContent => {
  const saveImage = async (url: string, postId: number) => {
    try {
      const response = await axios({
        //url: "https://localhost.reportermagazin.cz:3000/test-image.webp", //TODO: Local cors error -> before deploy change to post.audio?.url
        url,
        method: "GET",
        responseType: "blob", // important
      });
      const image = await resizeFile(await response?.data);
      const array = new Uint8Array(await (image as Blob).arrayBuffer());

      return db.imageSources.add({ postId: postId, source: array, originalUrl: url });
    } catch (error) {
      throw error;
    }

    return;
  };

  const resizeFile = (file: Blob) => {
    return new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        600,
        600,
        "JPEG",
        50,
        0,
        (url) => {
          resolve(url);
        },
        "blob"
      );
    });
  };

  const loadOfflineImage = useCallback(async (url: string) => {
    const record = await db.imageSources.where("originalUrl").equalsIgnoreCase(url).first();

    if (navigator.onLine) {
      return url;
    }

    if (record?.source) {
      return URL.createObjectURL(new Blob([record.source]));
    }

    return;
  }, []);

  return {
    loadOfflineImage,
    saveImage,
  };
};
